export default {
  product_info: 'Info prodotto',
  return: 'Torna alle opzioni',
};
